import React from 'react';
import HubsContainer from './HubsContainer';

const Hubs = () => <HubsContainer />;

export default Hubs;
